import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';
import { DEFAULT_DEBOUNCE_CHARACTERS } from 'src/app/extensions/constants/commonConstants';
import { debounce } from 'src/app/extensions/utilities';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { isEqual } from 'lodash';

@Component({
  selector: 'request-list-partner-filter',
  templateUrl: './request-list-partner-filter.component.html',
  styleUrls: ['./request-list-partner-filter.component.scss'],
  standalone: false,
})
export class RequestListPartnerFilterComponent {
  public constructor(
    private _activeModal: NgbActiveModal,
    private _partnerAPIService: PartnerAPIService
  ) {}

  partnerDataSource: app.models.Partner[] = [];
  hasPartners: boolean = true;
  partnerSearchValue: string;

  public requestModalFilters: app.models.GetRequestsForAdministrationModelPageFilter;

  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';
  public initialFilterState: app.models.GetRequestsForAdministrationModelPageFilter;

  public applyFilterHandler() {
    this._activeModal.close(
      isEqual(this.requestModalFilters, this.initialFilterState) ? false : this.requestModalFilters.partners.length
    );
  }

  public resetHandler() {
    this.requestModalFilters.partners = [];
    this._activeModal.close(isEqual(this.requestModalFilters, this.initialFilterState) ? false : 0);
  }

  public closeModalHandler() {
    this._activeModal.close(false);
  }

  filterDataSourceHandler = debounce((value: string) => {
    this.partnerSearchValue = value;
    value.length >= DEFAULT_DEBOUNCE_CHARACTERS
      ? this.loadAutocompleteDateSource(value)
      : (this.partnerDataSource = []);
  });

  async loadAutocompleteDateSource(input: string) {
    this.partnerDataSource = await this._partnerAPIService.getPartners(input).toPromise();
    this.hasPartners = this.partnerDataSource?.length > 0;
  }

  removeSelectedPartner(id: string) {
    this.requestModalFilters.partners = this.requestModalFilters.partners.filter(item => item.partnerId != id);
  }
}
